































import Vue from "vue";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean
    }
  },
  inject: ["actionHandler", "activeTab"],
  methods: {
    handleRowItemClick(event: Event) {
      this.actionHandler("rowselect", this.row);
    }
  }
});
